import type { Toaster } from '../component'
import { ReactToastify } from './ReactToastify'
import { ReactToastifyToastAction } from './ReactToastifyToastAction'

const toaster: Toaster = {
  toaster: ReactToastify,
  toastAction: ReactToastifyToastAction,
}

export default toaster
